module.exports = __webpack_public_path__ + "static/media/topbanner.4f3fb63d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/public/assets/images/banners/topbanner.jpeg
// module id = 1040
// module chunks = 0